<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
            class="mt-3 sidebar-hide-logo"
            :background-color="sidebarBackground"
            short-title="PB"
            title="Subscriptions Management"
            ref="sidebar"
    >
      <template slot-scope="props" slot="links">



         <sidebar-item
          :class="{ active: $route.fullPath === '/users' }"
          :link="{
            name: 'Управление подписками',
            icon: 'tim-icons icon-sound-wave',
            path: '/users'
          }"
        >
        </sidebar-item>

        <div @click.prevent="logout">
        <sidebar-item

          :link="{
            name: 'Выход из системы',
            icon: 'tim-icons icon-button-power',
            path: '#',
            isRoute: false,
          }"
        >
        </sidebar-item>
        </div>

      </template>


    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent, 'pt-3': true }"

      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './Navbar.vue';
import ContentFooter from './Footer.vue';
import DashboardContent from '../Layout/Content.vue';
import SidebarFixedToggleButton from '../Layout/SidebarFixedToggleButton.vue';
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition
  },
  data() {
    return {
      release: null,
      sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
    };
  },
  methods: {

    logout(){
      console.log("click")
      this.$store.dispatch('EMPTY_TOKEN');
      localStorage.removeItem("token");
      this.$notify({type: 'success', message: 'Выход из системы'});
      this.$router.push('/login');

    },

    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('main-panel');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  },
  async mounted() {
    let token = this.$store.getters.getToken;
    if (token === null || token === undefined){
      localStorage.removeItem('token');
      localStorage.removeItem('CurrentRelease');
      localStorage.removeItem('getCurrentTrack');
      localStorage.removeItem('currentReleases');
      localStorage.clear('token')
      await this.$store.dispatch('EMPTY_TOKEN');
      this.$router.push('/login');
    }
    this.initScrollbar();
    let filter = JSON.stringify({

      status: 1,


    });


    let response = await axios({
      method: 'GET',
      url: '/api/admin/release/get' + '?take=' + 1000 + '&skip=' + 0 + '&filters=' + filter,
      headers: {
        'token': token
      },
    });
    this.$notify({type: 'info', message: 'Имеется ' + response.data.releases.length + ' не проверенных релизов'});
    this.release = response.data.releases.length
  }
}
</script>
<style lang="scss">
$scaleSize: 0.95;

.sidebar-hide-logo{
  .logo{
    display: none;
  }

}

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
/*  .content {
    padding-top: 1% !important;
  }*/
</style>
